/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("RipGraphicController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class RipGraphicController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class RipGraphicController extends cls.ControllerBase /** @lends classes.RipGraphicController.prototype */ {
    static __name = "RipGraphicController";

    _initBehaviors() {
      super._initBehaviors();

      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.RipGraphicTypeVMBehavior);
      this._addBehavior(cls.Reverse4STBehavior);
    }
  }

  cls.RipGraphicController = RipGraphicController;
  cls.ControllerFactory.register("RipGraphic", cls.RipGraphicController);
});
